import { createSlice } from '@reduxjs/toolkit'
import { ModelOrder } from 'models/modelOrder'

export const ordersSlice = createSlice({
	name: 'orders',
	initialState: {
		isLoading: false,
		orders: null,
		/* TODO: all these (items) structure should be generated according to the user's actions */
	},
	reducers: {
		loaderStart: (state) => {
			state.isLoading = true
		},
		loaderStop: (state) => {
			state.isLoading = false
		},
		getOrdersSuccess: (state, { payload }) => {
			state.isLoading = false
			state.orders = payload?.data?.map((item) => {
				if (item.orderId === payload.orderId) {
					item.isOpen = true
					return ModelOrder(item)
				}
				return ModelOrder(item)
			})
		},
		updateOrders: (state, { payload }) => {
			let { orderId, isOpenByDefault = false } = payload
			state.orders = state.orders.map((i) => {
				if (i.orderId === orderId) {
					return {
						...i,
						isOpen: isOpenByDefault ? false : !i.isOpen,
					}
				}
				return i
			})
		},
		closeOpenedOrders: (state, { payload }) => {
			state.orders = state.orders.map((i) => {
				if (i.orderId === payload) {
					return {
						...i,
						isOpen: true,
					}
				}
				return {
					...i,
					isOpen: false,
					count: i.count + 1,
				}
			})
		},
		clearFlowOrder: (state, { payload }) => {
			state.orders = state?.orders?.map((i) => {
				if (i.orderId === payload) {
					return {
						...i,
						count: i.count + 1,
					}
				}
				return i
			})
		},
	},
})

export const {
	loaderStart,
	loaderStop,
	getOrdersSuccess,
	updateOrders,
	closeOpenedOrders,
	clearFlowOrder,
} = ordersSlice.actions
export const { reducer } = ordersSlice
